import { Translation } from '@/components/i18n/Translation'

import Page from '../content/Page'

const Orders = () => (
  <Page>
    <h1>
      <Translation id="Orders" />
    </h1>
  </Page>
)

export default Orders
